<nav class="navbar navbar-light" aria-label="Menú principal de componentes">
  <!-- Enlace Repositorio -->
  <app-link-repository [urlRepository]="urlRepository" *ngIf="verUrlRepository"></app-link-repository>
  <ul class="navbar-nav mb-2">
    <li class="nav-item">
      <a class="nav-link nav-item-text" routerLink="/home" routerLinkActive="active" #menuItem="routerLinkActive" [attr.aria-current]="menuItem.isActive ? 'page' : undefined" (click)="actionResponsive()">Inicio</a>
    </li>
    <li class="nav-item" *ngFor="let item of itemsMenu">
      <app-sidebar-modules [item]="item"></app-sidebar-modules>
    </li>
  </ul>
</nav>
